import { z } from "zod";

export const ContentLoadInstruction = z.object({
  from: z.string(),
  to: z.string(),
  authorizationHeaderKvsId: z.string().optional(),
  timeout: z.number().optional(),
});

export type ContentLoadInstruction = z.infer<typeof ContentLoadInstruction>;

export const ContentLoaderPayload = z
  .object({
    type: z.literal("Single"),
    instruction: ContentLoadInstruction,
  })
  .or(
    z.object({
      type: z.literal("Multiple"),
      loadingChunkSize: z.number().optional(),
      instructions: z.array(ContentLoadInstruction),
    })
  )
  .or(
    z.object({
      type: z.literal("S3"),
      location: z.string(),
    })
  );

export type ContentLoaderPayload = z.infer<typeof ContentLoaderPayload>;
